import { useState, useEffect } from 'react';
import { DateTime } from "luxon";

type Props = {
  startedAt?: DateTime;
  endedAt?: DateTime | null;
  decimals?: number; // default 1
};

export default function TimeCounter({startedAt, endedAt, decimals = 1}: Props) {
  const REFRESH_INTERVAL_MS = 1000;
  const [now, setNow] = useState(() => DateTime.now());

  // tick while no endedAt (live counter)
  useEffect(() => {
    if (endedAt) return;
    const id = window.setInterval(() => setNow(DateTime.now()), REFRESH_INTERVAL_MS);
    return () => clearInterval(id);
  }, [endedAt]);

  if (!startedAt) return <span/>;

	const end = endedAt === null ? null : endedAt === undefined ? now : endedAt;
  const diffHours = end === null ? 0 : Math.max(0, end.diff(startedAt).as('hours'));

  return (
    <span>
    { end === null ? '-' :
      diffHours.toLocaleString(undefined, {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        }
      )
    }
    </span>
  );
}
